export default __webpack_public_path__ + "static/media/land_rover.395a78fb.svg";